import appConfig from '../../config/appConfig';
import authDataStoreService from '../auth/authDataStoreService';
import * as gigyaService from '../gigya/gigyaService';
import storageService from '../storage/storageService';

const setSessionStorageData = () => {
    const spiceToken = authDataStoreService.getSpiceToken();
    const gigyaJWT = gigyaService.getGigyaToken();

    if (!spiceToken && !gigyaJWT) {
        storageService.setIsCompatiblePageOpenedToStorage(true);
    }
};

const getIsIntroPageVisible = () => {
    const isWebAppJourneyDisabled = appConfig.getIsWebAppJourneyDisabled();

    if (isWebAppJourneyDisabled) return true;

    const isCompatiblePageOpened = storageService.getIsCompatiblePageOpenedFromStorage();
    const spiceToken = authDataStoreService.getSpiceToken();
    const gigyaJWT = gigyaService.getGigyaToken();

    if (isCompatiblePageOpened && (spiceToken || gigyaJWT)) {
        storageService.removeIsCompatiblePageOpenedFromStorage();

        return false;
    }

    return true;
};

export default {
    getIsIntroPageVisible,
    setSessionStorageData,
};
